import { useDeleteWorklistTablePreferencesMutation } from '@common/cache';
import { ConfirmationModal } from 'components/ConfirmationModal';

// type ColumnKey = keyof NonNullable<TaskPreferences['columns']>;

// const COLUMN_KEYS: ColumnKey[] = [
//   'task',
//   'category',
//   'patient',
//   'priority',
//   'due_date',
//   'status',
//   'created_date',
//   'last_updated_at',
//   'provider',
//   'location',
//   'assignment',
// ] as const;

// const makeColumnsVisible = (columns?: TaskPreferences['columns']) => {
//   if (!columns) return {};
//
//   return Object.fromEntries(
//     COLUMN_KEYS.map((key, index) => [
//       key,
//       {
//         column_display: 'display',
//         column_size: columns[key]?.column_size ?? 120,
//         column_order: index + 1,
//       },
//     ]),
//   ) as Record<ColumnKey, ColumnPreferencesConfig>;
// };

export const TaskTableResetModal = ({
  isOpen,
  onClose,
  onResetAction,
}: {
  isOpen: boolean;
  onClose: () => void;
  onResetAction?: () => void;
}) => {
  // const { data: preferences } = useWorklistTablePreferencesQuery();
  const updatePreferencesMutation = useDeleteWorklistTablePreferencesMutation();

  // const resetState: TaskPreferences = {
  //   density: 'comfortable',
  //   page_size: 10,
  //   sort_by: 'task',
  //   sort_order: 'ASC',
  //   columns: makeColumnsVisible(preferences?.columns),
  // };

  const handleReset = async () => {
    await updatePreferencesMutation.mutateAsync();
    onResetAction?.();
    onClose();
  };

  return (
    <ConfirmationModal
      title={'Reset table view'}
      message={
        'This will restore the default columns, sorting, and filters. Your custom layout and pinned columns will be cleared.'
      }
      closeText='KEEP CURRENT VIEW'
      confirmText='RESET VIEW'
      onConfirm={handleReset}
      onClose={onClose}
      isOpen={isOpen}
      disableCloseOnOutsideClick={false}
      isLoading={updatePreferencesMutation.isPending}
      reverseButtonOrder
    />
  );
};
